<template>
  <div
    id="overlapped-header"
    v-bind:style="{
      background: isDarkTheme ? topBgColor : bgTheme,
      height: headerHeight,
      color: isDarkTheme ? headingTextColor : '#ffffff',
      borderBottomLeftRadius: '20px',
      borderBottomRightRadius: '20px',
      height: headerHeightValue
    }"
  >
    <div
      class="page-title align-hor center-ver space-between"
      v-bind:style="{
        background: isDarkTheme ? topBgColor : bgTheme,
        paddingBottom: computedPadding,
        paddingLeft: '10px'
      }"
    >
      <div class="align-hor center-ver">
        <div class="back-button" id="overlap-header-backbtn">
          <!-- <img
            class="medium-icon pull-left margin-10 pointer"
            src="@/assets/back-light.png"
            v-if="backButtonVisible"
            v-on:click="back"
          /> -->
          <back-icon v-if="backButtonVisible" @click="back" />
          <!-- <div class="pull-left padding-10" v-else></div> -->
        </div>
        <div
          class="text-left text-large display-flex"
          :style="{
            color: isDarkTheme ? headingTextColor : '#ffffff',
            fontSize: '18px'
          }"
        >
          {{ getTranslatedText(headerTitle) }}
          <!-- {{ model }} -->
        </div>
      </div>
      <div style="margin-right: 45px !important;" v-if="userHeaderBalance.show">
        <div
          class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor"
          v-if="headerTitle === 'Card Details'"
        >
          <img
            class="smaller-icon pull-left margin-right-0"
            :src="userHeaderBalanceGiftCard.reward_icon"
          />
          <span class="text-grey margin-vertical-10 align-hor center-ver">{{
            userHeaderBalanceGiftCard.balance +
              " " +
              userHeaderBalanceGiftCard.reward_type
          }}</span>
        </div>
        <div
          class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor"
          v-else
        >
          <img
            class="smaller-icon pull-left margin-right-0"
            :src="userHeaderBalance.icon"
          />
          <span class="text-grey margin-vertical-10 align-hor center-ver">{{
            userHeaderBalance.balance
          }}</span>
        </div>
      </div>
      <div
        v-if="model.isLeaderBoard"
        style="margin-right: 20px; padding-bottom: 10px; display: flex; justify-content: center; align-items: center; gap: 5px;"
      >
        <div>
          <history-icon
            @click="
              redirectTo('leaderboardContextHistory/' + model.leaderBoardId)
            "
          />
        </div>
        <!-- <img
          style="cursor: pointer;width:20px; margin-right: 10px;"
          class="smaller-icon pull-left"
          src="@/assets/Leaderboard Assest/History.svg"
          @click="
            redirectTo('leaderboardContextHistory/' + model.leaderBoardId)
          "
        /> -->

        <!-- {{ model.leaderBoardId }} -->
        <div style="padding-top: 5px;">
          <info-icon @click="toggleLeaderboardModal(true)" />
        </div>

        <!-- <img
          class="smaller-icon margin-right-5"
          style="width:20px"
          src="@/assets/Leaderboard Assest/info.svg"
          @click="toggleLeaderboardModal(true)"
        /> -->
      </div>
      <div
        v-if="model.isLeaderBoardHistory && !model.quizHistory"
        style="margin-right: 20px; display: flex;flex-direction: column;    align-items: center;    margin-top: 13px;"
      >
        <!-- <img
          style="cursor: pointer;width:25px"
          class="smaller-icon pull-left margin-right-5"
          src="@/assets/Leaderboard Assest/History.svg"
          @click="redirectTo('leaderboardHistory/' + model.leaderBoardId)"
        /> -->
        <history-icon
          @click="redirectTo('leaderboardHistory/' + model.leaderBoardId)"
        />
        <span :style="{ color: isDarkTheme ? headingTextColor : '#ffffff' }"
          >History</span
        >
        <!-- <span>History</span> -->
      </div>

      <!-- Quiz History -->
      <div
        v-if="model.quizHistory"
        style="margin-right: 20px; display: flex;flex-direction: column;    align-items: center; "
      >
        <!-- <history-icon @click="redirectTo('/quiz-history')" /> -->
        <router-link class="h-history" to="/quiz-history">
          <!-- <img
              src="@/assets/quiz-history.svg"
              alt="history"
              class="img-fluid"
            /> -->
          <history-icon />
        </router-link>
      </div>

      <div
        v-if="model.isRaffleHistory"
        style="margin-right: 20px; display: flex;flex-direction: column;    align-items: center;    margin-bottom: 10px;"
      >
        <!-- <img
          style="cursor: pointer;width:25px"
          class="smaller-icon pull-left margin-right-5"
          src="@/assets/Leaderboard Assest/History.svg"
          @click="redirectTo('raffleHistory')"
        /> -->
        <history-icon @click="redirectTo('raffleHistory')" />
        <!-- <span :style="{ color: isDarkTheme ? headingTextColor : '#ffffff' }"
          >History</span
        > -->
      </div>
    </div>
    <div
      v-if="
        !model.isRaffleHistory &&
          !model.isLeaderBoard &&
          !model.isLeaderBoardHistory
      "
      class="close-sdk-btn"
      @click="closeClick"
    >
      <close-icon @click="back" />
      <!-- <svg
        width="40"
        height="40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="12" fill-opacity="0.19"></rect>
        <path
          d="m14 26 12-12m0 12L14 14"
          stroke="#fff"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg> -->
    </div>

    <div class="user-details" v-if="!model.onlyHeader">
      <div
        class="uname text-large margin-bottom-20"
        :style="{
          visibility: userName == 'User' ? 'hidden' : 'visible',
          color: isDarkTheme ? headingTextColor : '#ffffff'
        }"
      >
        Hello {{ userName }}
      </div>
      <div
        class="ulevel align-hor center-ver margin-bottom-10 text-semi-small"
        v-if="isGamification"
      >
        <div
          class="icon-wrapper padding-5 radius50 bg-light align-hor center-ver center-hor margin-right-5"
          v-if="userCurrLevelIcon"
        >
          <img class="smaller-icon pull-left" :src="userCurrLevelIcon" />
        </div>
        <div
          class="icon-wrapper padding-5 radius50 bg-light align-hor center-ver center-hor margin-right-5"
          v-else
        >
          <img class="smaller-icon pull-left" src="@/assets/medal.svg" />
        </div>
        <div>{{ userCurrLevel }}</div>
      </div>
      <div
        class="ucredits align-hor space-between"
        style="justify-content: flex-end;"
      >
        <div
          class="credits align-hor center-ver"
          v-if="model.referrals"
          style=" width: 100%; overflow-x: auto; white-space: nowrap; padding-right: 5px; scrollbar-width: none;"
        >
          <div
            class="credit align-ver center-ver margin-right-10"
            v-for="urb in userReferralBalances"
            :key="urb.id"
          >
            <div
              class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor margin-bottom-5"
            >
              <img
                class="smaller-icon pull-left margin-right-5 margin-left-10"
                v-if="urb.reward_icon"
                :src="urb.reward_icon"
              />
              <span
                class="text-grey margin-vertical-10 align-hor center-ver"
                style="margin-left: 2px !important;"
                >{{ formatReward(urb.reward_type, urb.balance, false) }}</span
              >
            </div>
            <div style="padding-top: 2px">{{ urb.reward_type }}</div>
          </div>
        </div>
        <div
          class="credits align-hor center-ver"
          v-else-if="showCurrencyList"
          style=" width: 100%; overflow-x: auto; white-space: nowrap; padding-right: 5px; scrollbar-width: none;"
        >
          <div
            v-if="showActionButtonInRewards === true"
            class="credit align-ver center-ver margin-right-10 pointer"
            v-for="ub in computedUserBalances"
            @click="
              redirectTo('transactions', {
                type: ub.reward_type,
                is_redeemable: ub.is_redeemable,
                active_currency: active_currency
              })
            "
            :key="ub.id"
          >
            <div
              class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor"
            >
              <img
                class="smaller-icon pull-left margin-right-5 padding-left-5"
                :src="ub.reward_icon"
              />
              <span
                class=" margin-vertical-10 align-hor center-ver"
                style="margin-left: 2px !important; color: #323232;"
                >{{ formatReward(ub.reward_type, ub.balance, false) }}</span
              >
              <img
                class="super-small-icon"
                src="@/assets/right-arrow.svg"
                v-if="!model.referrals"
              />
            </div>
            <div v-if="showCurrencyName" class="padding-top-5">
              {{ ub.reward_type }}
            </div>
          </div>

          <div
            v-if="showActionButtonInRewards === false"
            class="credit align-ver center-ver margin-right-10 pointer"
            v-for="ub in computedUserBalances"
            :key="ub.id"
          >
            <div
              class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor"
            >
              <img
                class="smaller-icon pull-left margin-right-5 padding-left-5"
                :src="ub.reward_icon"
              />
              <span
                class="text-grey margin-vertical-10 align-hor center-ver"
                style="margin-left: 2px !important;"
                >{{ formatReward(ub.reward_type, ub.balance, false) }}</span
              >
              <img
                class="super-small-icon"
                src="@/assets/right-arrow.svg"
                v-if="!model.referrals"
              />
            </div>
            <div v-if="showCurrencyName" class="padding-top-5">
              {{ ub.reward_type }}
            </div>
          </div>
        </div>
        <div
          v-if="
            !useWallet &&
              showActionButton &&
              model.rewards &&
              computedUserBalances.length > 0
          "
          style="margin-left: 15px"
          class="border-light padding-0510 radius-30 start-align-self pointer"
        >
          <div
            class="wrap align-hor center-ver center-hor margin-vertical-10"
            v-if="model.rewards && computedUserBalances.length > 0"
            @click="
              redirectTo('transactions', {
                type: computedUserBalances[0].reward_type,
                is_redeemable: computedUserBalances[0].is_redeemable,
                active_currency: active_currency
              })
            "
          >
            <img
              class="smaller-icon pull-left margin-right-5"
              src="@/assets/wallet-o.svg"
            />
            Transactions
          </div>
        </div>

        <div v-if="showActionButton">
          <div v-if="useWallet && showActionButton" style="margin-top:5px">
            <div
              style="margin-left: 15px"
              class=" padding-0510 radius-30 start-align-self pointer"
              v-if="!model.referrals"
              :style="{
                border: `1px solid ${
                  isDarkTheme ? headingTextColor : '#ffffff'
                }`
              }"
            >
              <div
                class="wrap align-hor center-ver center-hor margin-vertical-10"
                v-if="model.rewards"
                @click="redirectTo('wallet')"
              >
                <!-- <img
                  class="smaller-icon pull-left margin-right-5"
                  src="@/assets/WalletIcon.svg"
                  style="color: green;"
                /> -->
                <wallet-icon />
                Wallet
              </div>
              <div
                class="wrap align-hor center-ver center-hor margin-vertical-10"
                v-else
                @click="redirectTo('rewards')"
              >
                <RewardIcon
                  :iconColor="isDarkTheme ? headingTextColor : '#ffffff'"
                />

                Rewards
              </div>
            </div>
          </div>
          <div v-else style="margin-top:5px">
            <div
              style="margin-left: 15px"
              class="border-light padding-0510 radius-30 start-align-self pointer"
              v-if="!model.referrals && !model.rewards && showActionButton"
            >
              <div
                class="wrap align-hor center-ver center-hor margin-vertical-10"
                @click="redirectTo('rewards')"
              >
                <img
                  class="smaller-icon pull-left margin-right-5"
                  src="@/assets/reward-o.svg"
                />
                Rewards
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import Header from "@/components/header";
import BackIcon from "@/components/back-icon.vue";
import CloseIcon from "@/components/close-icon.vue";
import BadgeIcon from "@/components/badge-icon.vue";
import RewardIcon from "@/components/badge-icon.vue";
import WalletIcon from "@/components/wallet-icon.vue";
import HistoryIcon from "@/components/history-icon.vue";
import InfoIcon from "@/components/info-icon.vue";
import { height } from "@fortawesome/free-regular-svg-icons/faAddressBook";
// import InfoIcon from "./info-icon.vue";
export default {
  mixins: [globals],
  props: {
    model: Object
  },
  components: {
    "custom-header": Header,
    BackIcon,
    CloseIcon,
    "bagde-icon": BadgeIcon,
    "wallet-icon": WalletIcon,
    RewardIcon,
    HistoryIcon,
    InfoIcon
  },
  data() {
    return {
      isMounted: false,
      active_currency: ""
    };
  },
  computed: {
    headerHeightValue() {
      const title =
        this.headerTitle && typeof this.headerTitle === "string"
          ? this.headerTitle.toLowerCase()
          : "";

      // Offers & Rewards → 250px
      if (title === "offers" || title === "rewards" || "referrals") {
        return "250px";
      }

      // All other screens → 180px
      return "180px";
    },
    // headerHeightValue() {
    //   const title =
    //     this.headerTitle && typeof this.headerTitle === "string"
    //       ? this.headerTitle.toLowerCase()
    //       : "";

    //   if (title === "poll" || title === "survey" || title === "trivia") {
    //     return "180px";
    //   }

    //   return "250px";
    // },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    headerHeight() {
      if (this.referralWalletData || this.$route.path != "/referrals") {
        return "250px";
      } else {
        return "200px";
      }
    },
    computedUserBalances() {
      return this.userBalances.filter(item => {
        return item.reward_type != "Stamps";
      });
    },
    computedPadding() {
      return this.headerTitle === "Card Details" ? "25px" : "0px";
    },
    computedUserBalances() {
      return this.userBalances.filter(item => item.reward_type != "Stamps");
    }
  },
  beforeMount() {
    this.isMounted = true;
  },
  // computed: {
  //   computedUserBalances() {
  //     return this.userBalances.filter(item => item.reward_type != "Stamps");
  //   }
  // },
  mounted() {},
  methods: {
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    closeClick() {
      window.parent.postMessage("close-sdk", "*");
      // if(window.webkit) {
      //   window.webkit.messageHandlers.handleMessage.postMessage('close-sdk');
      // } else {
      //   window.parent.postMessage('close-sdk', '*')
      // }
    }
  },
  created() {
    this.loadDataFromCookie();
    // this.getFlyyAppinfov1();
    this.active_currency = this.$store.state.active_currency.label;
  }
};
</script>
<style>
#overlapped-header {
  /* height: 250px !important; */
  text-align: left;
}
.user-details {
  padding: 64px 15px 0px;
}
.display-flex {
  display: flex;
  align-items: center;
}
.page-title {
  height: 64px;
  position: fixed;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2;
}
.icon-wrapper {
  height: 15px;
  width: 15px;
}
.credit .wrap {
  min-width: 50px;
}
.close-sdk-btn {
  position: fixed;
  top: 4px;
  right: 0px;
  cursor: pointer;
  z-index: 9999999;
}
</style>
